import React from "react";
import { Router } from "@reach/router";
import Redirect from "components/redirect";
import Dashboard from "./dashboard";
// ESD Requirements
import BusinessOverview from "./maintenance/business-overview";
import BusinessInformation from "./maintenance/business-information";
import Finance from "./maintenance/finance";
import Staffing from "./maintenance/staffing";
import Marketing from "./maintenance/marketing";
import OperationalManagement from "./maintenance/operational-management";
import IT from "./maintenance/information-technology";

import routes from "utils/absoluteRoutes";
import styled from "styled-components";
import queries, { minQuery, devices } from "utils/responsivenessHelper";

const StyledRouter = styled(Router).attrs({
  className: "router",
})`
  position: relative;
  margin-bottom: 50px;

  ${minQuery.both(
    {
      marginBottom: "20%",
    },
    null,
    devices.iPadPro
  )}

  ${queries.portrait(
    {
      marginBottom: 0,
    },
    devices.iPadPro
  )}
`;

const MaintenanceRoutes = () => {
  return (
    <StyledRouter>
      <Redirect default to={routes.redirects.notFound} />
      <BusinessOverview path="business-overview/*" />
      <BusinessInformation path="business-information/*" />
      <Finance path="finance/*" />
      <Staffing path="staffing/*" />
      <Marketing path="marketing/*" />
      <OperationalManagement path="operational-management/*" />
      <IT path="information-technology/*" />
    </StyledRouter>
  );
};

const BizProfileRoutes = () => {
  return (
    <Router className="router">
      <Redirect default to={routes.redirects.notFound} />
      <Dashboard path="/" />
      <MaintenanceRoutes path="/*" />
    </Router>
  );
};

export default BizProfileRoutes;
